import { io } from "socket.io-client";

const URL = process.env.REACT_APP_BASE_URL;
const socket = io(URL, {
  autoConnect: true,
  transports: ["websocket", "polling", "flashsocket"],
});

export default socket;
